import Dragger from 'antd/es/upload/Dragger'
import { VStack } from 'govwell-ui'

import FileCard from 'src/components/FilesUpload/FileCard'
import { Done } from 'src/components/FileUpload/states/Done'
import { Error } from 'src/components/FileUpload/states/Error'
import { getDraggerClassNames } from 'src/components/FileUpload/util'

import { FileUploadStatuses } from '../../hooks/use-file-upload-state'
import {
  FilesUploadState,
  UploadMultipleFilesFileUploadState,
} from '../../hooks/use-files-upload-state'
import { Default } from '../FileUpload/states/Default'
import { Uploading } from '../FileUpload/states/Uploading'

type Props = FilesUploadState & {
  accept?: string
  disabled?: boolean
  fieldName?: string
  error?: boolean
}
export const FilesUpload = ({
  accept,
  disabled,
  setName,
  states,
  beforeUpload,
  removeFile,
  error,
}: Props) => {
  return (
    <div className="w-full">
      <VStack gap={2} align="stretch" className={states.length ? 'mb-2' : ''}>
        {states.map((state: UploadMultipleFilesFileUploadState) => {
          if (state.status === FileUploadStatuses.Uploading) {
            return (
              <FileCard key={state.id} isInvalid={false}>
                <Uploading
                  {...state}
                  key={state.id}
                  fileName={state.name}
                  onRemove={() => removeFile(state.id)}
                />
              </FileCard>
            )
          }
          if (
            state.status === FileUploadStatuses.Done ||
            state.status === FileUploadStatuses.Existing
          ) {
            return (
              <FileCard key={state.id} isInvalid={false}>
                <Done
                  {...state}
                  id={state.govWellFileId}
                  onRemoveFile={() => removeFile(state.id)}
                  onRenameFile={(fileName: string) => setName(state.id, fileName)}
                />
              </FileCard>
            )
          }
          if (state.status === FileUploadStatuses.Error) {
            return (
              <FileCard key={state.id} isInvalid>
                <Error
                  key={state.id}
                  {...state}
                  onClick={() => removeFile(state.id)}
                  actionLabel="Remove file"
                  actionIcon="FaTrash"
                />
              </FileCard>
            )
          }
        })}
      </VStack>
      <Dragger
        accept={accept}
        disabled={disabled}
        name="file"
        action=""
        multiple
        beforeUpload={beforeUpload}
        className={getDraggerClassNames({
          asChild: false,
          isInvalid: !!error,
        })}
      >
        <Default accept={accept} />
      </Dragger>
    </div>
  )
}
